import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "processingError",
  "use": "processingError-usage",
  "viewBox": "0 0 73 73",
  "content": "<symbol viewBox=\"0 0 73 73\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"processingError\">\n    <rect x=\"0.5\" y=\"0.5\" width=\"72\" height=\"72\" rx=\"36\" fill=\"#FF3B30\" />\n    <path d=\"M36.5 38.6071L43.3929 45.5L45.5 43.3929L38.6071 36.5L45.5 29.6071L43.3929 27.5L36.5 34.3929L29.6071 27.5L27.5 29.6071L34.3929 36.5L27.5 43.3929L29.6071 45.5L36.5 38.6071Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol